const moment = require('moment');

export default {
  getStoreByCharityId: (state) => (charityId) =>
    state.stores[charityId] || null,
  getClientToken: (state) => (charityId) =>
    state.clientTokens[charityId] || null,
  /**
   * Parse the claims from the access token and return them with no additional checks.
   */
  getClientTokenClaims: (state, getters) => (charityId) => {
    const tokenData = getters.getClientToken(charityId);
    if (!tokenData?.accessToken) {
      return null;
    }

    const tokenParts = tokenData.accessToken.split(".");
    return JSON.parse(window.atob(tokenParts[1]));
  },
  /**
   * Parse the claims from the access token and validate them.
   */
  isClientTokenValid: (state, getters) => (charityId) => {
    const tokenData = getters.getClientToken(charityId);
    const claims = getters.getClientTokenClaims(charityId);
    if (!tokenData || !claims) {
      return false;
    }

    const now = Math.floor(Date.now() / 1000);
    if (claims.exp && claims.exp < now) {
      return false;
    }

    // basically the same as above, but we'll double check
    if (
      claims.iat &&
      tokenData?.expiresIn &&
      claims.iat + tokenData?.expiresIn < now
    ) {
      return false;
    }

    return true;
  },
  getEventCount: state => {
    return state.events.length
  },
  getEventsData: state => {
    return state.events.reduce((eventData, event) => {
      eventData['ticketSold'] = eventData['ticketSold'] + event.stock.netSales
      eventData['revenue'] = eventData['revenue'] + event.stock.revenue

      return eventData
    }, {ticketSold: 0, revenue: 0})
  },
  getTicketsData: state => {
    const { tickets } = state;
    const weekAgo = moment().subtract(7, 'days');
    const monthAgo = moment().subtract(30, 'days');
    const yearAgo = moment().subtract(12, 'months');
    const baseTicketsData = { quantity: 0, cost: 0 };

    const ticketsData = tickets.reduce((sum, transaction) => {
      if (!transaction.products) return sum;

      const { createdAt, products } = transaction;
      const transactionCreatedAt = moment(createdAt);
      const transactionTicketQuantity = products.reduce((tsum, product) => tsum + product.quantity, 0);
      const transactionTicketCost = products.reduce((tsum, product) => tsum + product.cost, 0);

      if (transactionCreatedAt > weekAgo) {
        sum.weekly.quantity += transactionTicketQuantity;
        sum.weekly.cost += transactionTicketCost;
      }
      if (transactionCreatedAt > monthAgo) {
        sum.monthly.quantity += transactionTicketQuantity;
        sum.monthly.cost += transactionTicketCost;
      }
      if (transactionCreatedAt > yearAgo) {
        sum.yearly.quantity += transactionTicketQuantity;
        sum.yearly.cost += transactionTicketCost;
      }
      sum.allTime.quantity += transactionTicketQuantity;
      sum.allTime.cost += transactionTicketCost;
      return sum;
    }, {
      weekly: { ...baseTicketsData },
      monthly: { ...baseTicketsData },
      yearly: { ...baseTicketsData },
      allTime: { ...baseTicketsData },
    });

    // Cents —› Dollars
    Object.keys(ticketsData).forEach(key => {
      ticketsData[key].cost /= 100;
    });

    return ticketsData;
  }
}
